module.exports = __webpack_public_path__ + "img/stephane-bourez-mech.ed1b48a.jpg";